import { gql } from '@apollo/client';

export const CREATE_NODE = gql`
  mutation CreateNode($params: CreateNodeInput!) {
    createNode(params: $params) {
      success
      message
      errors
      data {
        id
        code
        name
        keywords
        semanticWeight
        order
        createdAt
        createdBy
        updatedAt
        updatedBy
      }
    }
  }
`;

export const UPDATE_NODE = gql`
  mutation UpdateNode($params: UpdateNodeInput!) {
    updateNode(params: $params) {
      success
      message
      errors
      data {
        id
        code
        name
        keywords
        semanticWeight
        order
        createdAt
        createdBy
        updatedAt
        updatedBy
      }
    }
  }
`;

export const DELETE_NODE = gql`
  mutation DeleteNode($params: DeleteNodeInput!) {
    deleteNode(params: $params) {
      success
      message
      errors
    }
  }
`;
